<h1 class="pl-4">Strona główna</h1>
<div class="flex flex-col gap-4 p-4">
  <div
    class="grid grid-cols-2 max-[30rem]:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2"
  >
    @for (item of menuItems(); track item.label) {
      <div
        class="nav-card-wrapper"
        tabindex="0"
        (click)="nagivateToView(item.route)"
        (keydown.enter)="nagivateToView(item.route)"
      >
        <app-admin-panel-nav-card [label]="item.label" [icon]="item.icon" />
      </div>
    }
  </div>
</div>
